import { Link } from "react-router-dom";
import { Loader2, AlertTriangle, PackageX } from "lucide-react";
import { Button, ButtonLink } from "@/components/ui/Primitives";

export function LoadingState({ label = "Loading…" }) {
  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center gap-3 text-brand-navy/70">
      <Loader2 className="w-8 h-8 animate-spin text-brand-orange" />
      <p className="font-medium">{label}</p>
    </div>
  );
}

export function ErrorState({ onRetry }) {
  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center gap-4 text-center px-6">
      <AlertTriangle className="w-10 h-10 text-brand-orange" />
      <div>
        <h2 className="display-title text-2xl text-brand-navy">Something went wrong</h2>
        <p className="text-brand-navy/70 mt-1">We couldn't load this page. Please try again in a moment.</p>
      </div>
      {onRetry && <Button onClick={onRetry}>Try again</Button>}
    </div>
  );
}

export function NotFoundState() {
  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center gap-4 text-center px-6">
      <PackageX className="w-10 h-10 text-brand-orange" />
      <div>
        <h2 className="display-title text-2xl text-brand-navy">We couldn't find that</h2>
        <p className="text-brand-navy/70 mt-1">This activity isn't available yet.</p>
      </div>
      <ButtonLink to="/activities">Back to activities</ButtonLink>
    </div>
  );
}
